'use strict';
define([
    'angular',
    'modules/seospider/exam/analysis/detail/links/links.controller'
],function(angular,SinglePageLinksController){
    var app=angular.module('app.seospider.exam.analysis.detail.links', []);
    app.controller('SinglePageLinksController',SinglePageLinksController);
    return app;
});